<template>
 
  <div class="page"> 
    
    <!-- <div class="avaf"> 
      <img loading="lazy" class="ava" @click="avatarRandHandler" :src="'/avatars/' + avatar_num + '.jpg'">
      <div class="btn gray btn_rnd" @click="avatarRandHandler" type="is-primary"><i class="icon-shuffle"></i> {{ $t('signup_view_avatar_random') }}</div>
    </div> -->

    <!-- {{ selectedAvatar }} -->


    <!-- {{ selectedAvatar.file.name }} -->
 

    <UserAvatarSelector 
      @update:file="onAvatarFileUpdate" 
      @update:num="onAvatarNumUpdate"
      />


    <UiInput
      :label="$t('signup_view_username')"
      :text="form.name.value"
      :name="'nick'"
      :locator="'signup_view_username_locator'"
      :error="nameError"
      @change:text="form.name.value = $event"
      @keyup.enter="signUpHandler"
      @input="markInteracted('name')"
      @blur="markDirty('name')"
      />

    <UiInput
      :label="$t('signup_view_email')"
      :text="form.email.value"
      :name="'email'"
      :locator="'signup_view_email_locator'"
      :error="emailError"
      autocomplete="username email"
      @change:text="form.email.value = $event"
      @keyup.enter="signUpHandler"
      @input="markInteracted('email')"
      @blur="markDirty('email')"
      />

    <UiInput
      :label="$t('signup_view_password')"
      :text="form.password.value"
      :error="passwordError"
      type="password"
      autocomplete="new-password"
      :name="'password'"
      :locator="'signup_view_password_locator'"
      @change:text="form.password.value = $event"
      @keyup.enter="signUpHandler"
      @input="markInteracted('password')"
      @focus="showPasswordCheck = true"
      @blur="() => { showPasswordCheck = false; markDirty('password') }"
      ref="elPassword"
      />

    <ClientOnly>
      <UiTooltip 
        :target-el="elPassword" 
        preferred-placement="bottom" 
        :max-width="300"
        :isOpen="showPasswordCheck"
        :show-on-focus="false"
        >
        <UiPasswordCheck 
          :password="form.password.value" />
      </UiTooltip>
    </ClientOnly>
    
    <UiInput      
      :label="$t('signup_view_password2')"
      :text="form.password_repeat.value"
      :error="passwordRepeatError"
      type="password"
      :name="'password2'"
      :locator="'signup_view_password2_locator'"
      @change:text="form.password_repeat.value = $event"
      @keyup.enter="signUpHandler"
      @input="markInteracted('password_repeat')"
      @blur="markDirty('password_repeat')"
      />


    <div class="nwsl">
      <UiToggle 
        @update:modelValue="switchEnableNewsletter"
        :label="'Send me promotional emails'"
        v-model="form.is_subscribed.value" 
        />
    </div>




    <div v-if="generalError" class="general-error-block">
      {{ generalError }}
    </div>

    
    <NuxtTurnstile class="turnstile" ref="turnstile" v-model="token" />
 

    <UiButtonGroup>
      <UiButton
        :name="$t('signup_view_registration')"
        :type="'primary'"
        :locator="'signup_view_registration_locator'"
        @click="signUpHandler"
        :is-loading="isLoading"
        />        

      <UiButton
        :name="$t('signup_view_approve_login')"
        :tag="'NuxtLink'"
        :type="'link'"
        to="/auth/signin"
        />     

      <UiButton
        :name="$t('universal_button_cancel')"
        :tag="'NuxtLink'"
        :type="'link'"
        to="/"
        />     
    </UiButtonGroup>



    
  </div>  
  
</template>




<script setup lang="ts">
import { useFormValidation } from '~/composables/useFormValidation'
import { signupFormConfig } from '~/types/validation/formsConfig'

definePageMeta({
  auth: false,
  layout: "short",
})

const { t } = useI18n();
const router = useRouter();
const { $api, $refs, $ga } = useNuxtApp()
const { login, setSession, signIn } = useAuth()
const isLoading = ref(false)
const token = ref(null)
const turnstile = ref()
const showPasswordCheck = ref(false)
const elPassword = ref(null)
const generalError = ref('')


const avatar_num = ref(Math.floor(Math.random() * 83) + 1)

const selectedAvatar = ref(null); 

const onAvatarFileUpdate = (file) => {
  selectedAvatar.value = file;
};
const onAvatarNumUpdate = (num) => {
  avatar_num.value = num;
  selectedAvatar.value = null;
};

const form = reactive({
  name: {
    value: '', 
    isInteracted: false, 
    isDirty: false 
  },
  email: { 
    value: router.currentRoute?.value.query?.email?.toString() || '', 
    isInteracted: false, 
    isDirty: false 
  },
  password: { 
    value: '', 
    isInteracted: false, 
    isDirty: false 
  },
  password_repeat: { 
    value: '', 
    isInteracted: false, 
    isDirty: false 
  },
  is_subscribed: {
    value: true, 
    isInteracted: false, 
    isDirty: false,
    isOptional: true
  }
})

const { validateField, markInteracted, markDirty, validateForm } = useFormValidation(form, signupFormConfig)

const validation = {
  name: computed(() => validateField('name')),
  email: computed(() => validateField('email')),
  password: computed(() => validateField('password')),
  password_repeat: computed(() => validateField('password_repeat'))
}

const backendErrors = reactive({
  name: '',
  email: '',
  password: '',
  password_repeat: ''
})

const nameError = computed(() => backendErrors.name || validation.name.value.errorMessage)
const emailError = computed(() => backendErrors.email || validation.email.value.errorMessage)
const passwordError = computed(() => backendErrors.password || validation.password.value.errorMessage)
const passwordRepeatError = computed(() => backendErrors.password_repeat || validation.password_repeat.value.errorMessage)

const validate = () => validateForm()

const doneSignUp = () => { 
  useAuth().refresh();
  isLoading.value = false;    
  useToast().success('Success');
  router.push('/');

  $ga.addGrower();
  $ga.eventGA('user_signup');
}


const uploadAvatar = async (id) => { 
  if (!selectedAvatar.value?.file) return;
  let formData = new FormData();  
  formData.append('file', selectedAvatar.value.file, selectedAvatar.value.file.name);       
  await $api.postGrowersAvatars(id, formData);
};

const switchEnableNewsletter = (val) => {
  form.is_subscribed.value = val ? true : false;
};

const signUpHandler = async () => { 
  backendErrors.name = ''
  backendErrors.email = ''
  backendErrors.password = ''
  backendErrors.password_repeat = ''



  if (!validate()) {
    return false;
  }

  isLoading.value = true;

  try {
    const responseSignUp = await $api.postGrowers({ 
      name: form.name.value, 
      email: form.email.value.toLowerCase().trim(),
      password: form.password.value, 
      password_repeat: form.password_repeat.value, 
      is_subscribed: form.is_subscribed.value ? true : false,
      avatar_num: selectedAvatar.value?.file ? null : avatar_num.value,
      recaptcha: token.value
    });

    await setSession(responseSignUp.data.token);
    await uploadAvatar(responseSignUp.data.id);
    doneSignUp();

    useToast().success('Success');

  } catch (error: any) {
    turnstile.value?.reset();
    isLoading.value = false;

    switch (error.data?.code) {
      case 'U1001':
        form.name.isDirty = true
        form.name.isInteracted = true
        backendErrors.name = t('signup_view_error_username_in_use')
        break
      case 'U1002':
        form.email.isDirty = true
        form.email.isInteracted = true
        backendErrors.email = t('signup_view_error_email_in_use')
        break
      case 'U1010':
        form.password.isDirty = true
        form.password.isInteracted = true
        backendErrors.password = t('signup_view_error_password_mask_constraint')
        break
      case 'U1012':
        form.password_repeat.isDirty = true
        form.password_repeat.isInteracted = true
        backendErrors.password_repeat = t('signup_view_error_password_match')
        break
      default:
        generalError.value = t('universal_generic_error')
    }
  }
};

onMounted(() => {
  useHead(useNuxtApp().$head.getLogin());
})
</script>

<style scoped>

.page{
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 300px;
}
.ava{
  max-width: 180px;
  border-radius: 100%;
  display: block;
  cursor: pointer;
}
.avaf{
  margin-bottom: 1rem;
  text-align: center;
}
label{
  text-align: center;
}
.btn_rnd{
  display: block;
    z-index: 1;
    position: relative;
    width: fit-content;
    margin: 0 auto;
    margin-top: -28px;
}
.nwsl{
  margin-bottom: 1rem;
  margin-top: 0.5rem;
}
</style>
